<template>
  <div class="recharge-container">
    <div v-if="!showPaymentPage && !showPaymentFailed && !showPaymentSuccess" class="recharge-content">
      <!-- 页面标题 -->
      <div class="page-title">充值</div>

      <!-- 当前金额卡片 -->
      <div class="info-card">
        <div class="card-label balance-label">当前余额</div>
        <div class="current-amount">¥ {{ balance }}</div>
      </div>

      <!-- 输入金额卡片 -->
      <div class="info-card">
        <div class="card-label">输入金额</div>
        <div class="input-container">
          <span class="currency-symbol">¥</span>
          <input
            type="number"
            v-model.number="selectedOption"
            class="amount-input"
            placeholder="请输入充值金额"
            min="1"
            max="50"
            step="1"
          />
        </div>
        <div class="amount-hint">
          最低充值金额 ¥1, 最高充值金额 ¥50
        </div>
      </div>

      <!-- 充值方式卡片 -->
      <div class="info-card">
        <div class="card-label">充值方式</div>
        <div class="payment-methods">
          <!-- 微信支付
          <div
            class="payment-method"
            :class="{ selected: selectedMethod === '微信支付' }"
            @click="selectMethod('微信支付')"
          >
            <div class="payment-icon-container">
              <svg t="1762418155784" class="payment-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1687" width="24" height="24">
                <path d="M512 1024a512 512 0 1 1 512-512 512 512 0 0 1-512 512z m-112.523636-836.538182c-144.989091 0-262.516364 100.538182-262.516364 224.465455 0 74.007273 42.123636 139.636364 106.705455 180.363636l-19.549091 78.312727 86.807272-47.592727a301.265455 301.265455 0 0 0 88.669091 13.381818h2.210909a178.967273 178.967273 0 0 1-3.607272-34.909091c0-115.083636 109.498182-208.407273 244.363636-208.407272 6.167273 0 11.636364 0 18.152727 0.814545-10.589091-115.665455-123.461818-206.778182-261.469091-206.778182z m246.690909 226.443637c-124.741818 0-225.861818 86.109091-225.861818 192.465454s101.003636 192.349091 225.861818 192.349091a257.047273 257.047273 0 0 0 99.723636-20.014545l77.265455 40.610909L802.909091 744.727273a179.316364 179.316364 0 0 0 69.003636-138.24c0-106.24-101.12-192.465455-225.861818-192.465455z m81.454545 152.087272a31.767273 31.767273 0 1 1 32.349091-31.767272 32 32 0 0 1-32.349091 31.767272z m-164.072727 0a31.767273 31.767273 0 1 1 32.349091-31.767272 32 32 0 0 1-32.349091 31.767272zM502.341818 373.527273a34.909091 34.909091 0 1 1 34.909091-34.909091 34.909091 34.909091 0 0 1-34.909091 34.909091z m-206.196363 0a34.909091 34.909091 0 1 1 34.90909-34.909091 34.909091 34.909091 0 0 1-34.90909 34.909091z m0 0" fill="#1FBE2A" p-id="1688"></path>
              </svg>
            </div>
            <div class="payment-text">微信支付</div>
          </div> -->

          <!-- 支付宝支付 -->
          <div
            class="payment-method"
            :class="{ selected: selectedMethod === '支付宝支付' }"
            @click="selectMethod('支付宝支付')"
          >
            <div class="payment-icon-container">
              <svg class="payment-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path d="M230.771014 576.556522c-12.614493 9.646377-25.228986 23.744928-28.93913 42.295652-5.194203 24.486957-0.742029 55.652174 22.26087 80.13913 28.93913 28.93913 72.718841 37.101449 92.011594 38.585508 51.2 3.710145 106.110145-22.26087 147.663768-50.457971 16.324638-11.130435 43.77971-34.133333 70.492754-69.750725-59.362319-30.423188-133.565217-64.556522-212.22029-61.588406-41.553623 1.484058-70.492754 9.646377-91.269566 20.776812zM983.188406 712.347826c25.971014-61.588406 40.811594-129.113043 40.811594-200.347826 0-281.971014-230.028986-512-512-512S0 230.028986 0 512s230.028986 512 512 512c170.666667 0 321.298551-83.849275 414.794203-212.22029C838.492754 768.742029 693.797101 696.023188 604.011594 652.985507c-42.295652 48.973913-105.368116 97.205797-176.602898 117.982609-44.521739 13.356522-85.333333 18.550725-126.886957 9.646377-42.295652-8.904348-72.718841-28.197101-90.527536-47.489855-8.904348-10.388406-19.292754-22.26087-27.455073-37.843479 0.742029 0.742029 0.742029 2.226087 0.742029 2.968116 0 0-4.452174-7.42029-7.420289-19.292753-1.484058-5.936232-2.968116-11.872464-3.710145-17.808696-0.742029-4.452174-0.742029-8.904348 0-12.614493-0.742029-7.42029 0-15.582609 1.484058-23.744927 4.452174-20.776812 12.614493-43.77971 35.617391-65.298551 48.973913-48.231884 115.014493-50.457971 149.147826-50.457971 50.457971 0.742029 138.017391 22.26087 212.22029 48.973913 20.776812-43.77971 34.133333-89.785507 42.295652-121.692754H304.973913v-33.391304h158.052174v-66.782609H272.324638v-34.133333h190.701449v-66.782609c0-8.904348 2.226087-16.324638 16.324638-16.324637h74.944927v83.107246h207.026087v33.391304H554.295652v66.782609H719.768116S702.701449 494.933333 651.501449 586.202899c115.014493 40.811594 277.518841 104.626087 331.686957 126.144927z m0 0" fill="#06B4FD"/>
              </svg>
            </div>
            <div class="payment-text">支付宝支付</div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="button-group"><!--
        <button class="btn-secondary" @click="handleBack">返回</button> -->
        <button class="btn-primary" @click="createPayment">充值</button>
      </div>
    </div>

    <!-- 支付页面 -->
    <div v-else-if="showPaymentPage" class="payment-page">
      <div v-if="!isTimeout" class="payment-content">
        <div class="header">
          交易将在 <span class="countdown">{{ countdown }}</span> 后关闭,请及时付款!
        </div>
        <div class="amount-instruction" v-if="paymentAmount">
          <span>交易金额</span>
          <span class="price">¥ {{ paymentAmount }}</span>
          <span>请使用{{ selectedMethod }}扫描下方二维码支付</span>
        </div>
        <div class="qr-code-container">
          <img :src="qrCodeUrl" alt="QR Code" class="qr-code" v-if="qrCodeUrl" />
        </div>
      </div>

      <div v-else class="timeout-content">
        <div class="icon">⚠️</div>
        <div class="title">支付超时</div>
        <div class="message">抱歉,您的支付已超时,请返回充值页面重新发起</div>
      </div>

      <div class="buttons">
        <button @click="handleBack" class="back-button">返回</button>
        <button v-if="!isTimeout" @click="handlePaymentComplete" class="confirm-button">我已经支付完成</button>
      </div>
    </div>

    <!-- 支付失败页面 -->
    <div v-else-if="showPaymentFailed" class="payment-failed">
      <div class="icon">❌</div>
      <h2>支付失败</h2>
      <p>充值失败,请重新发起支付,如有疑问请联系客服:19872424497</p>
      <button @click="handleBack" class="retry-button">返回充值页面</button>
    </div>

    <!-- 支付成功页面 -->
    <div v-else-if="showPaymentSuccess" class="payment-success">
      <div class="icon">✔️</div>
      <h2>支付成功</h2>
      <p>充值金额: ¥{{ selectedOption }} 当前余额: ¥{{ currentBalance }}</p>
      <button @click="handlePaymentSuccess" class="back-button">查看详情</button>
    </div>
  </div>
</template>

<script>
import { createOrder, checkOrderStatus } from '@/api/pay'
// import { getUserInfo } from '@/api/upfile'
import QRCode from 'qrcode'

export default {
  data () {
    return {
      balance: 0,
      selectedOption: null,
      selectedMethod: '支付宝支付',
      showPaymentPage: false,
      showPaymentFailed: false,
      showPaymentSuccess: false,
      countdown: '0:60',
      timer: null,
      paymentAmount: null,
      qrCodeUrl: null,
      isTimeout: false,
      pollingTimer: null,
      currentBalance: 0,
      orderId: null,
      isLoading: true
    }
  },
  async created () {
    await this.fetchUserInfo()
  },
  methods: {
    async fetchUserInfo () {
      alert('enter fetchUserInfo')
      /* try {
        this.isLoading = true
        const response = await getUserInfo()
        if (response.status === 200) {
          const balance = response.data.account_balance || 0
          this.balance = parseFloat(balance).toFixed(2)
          this.currentBalance = this.balance
          alert(balance)
        } else {
          console.error('获取用户信息失败:', response.message)
          alert(response.message)
        }
      } catch (error) {
        console.error('获取用户信息出错:', error)
      } finally {
        this.isLoading = false
      } */
    },
    selectMethod (method) {
      this.selectedMethod = method
    },
    startCountdown () {
      let [minutes, seconds] = this.countdown.split(':').map(Number)
      let totalSeconds = minutes * 60 + seconds

      this.timer = setInterval(() => {
        if (totalSeconds > 0) {
          totalSeconds--
          minutes = Math.floor(totalSeconds / 60)
          seconds = totalSeconds % 60
          this.countdown = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        } else {
          this.clearCountdown()
          this.isTimeout = true
          this.showPaymentPage = false
          this.showPaymentFailed = true
        }
      }, 1000)

      this.startPolling()
    },
    startPolling () {
      this.pollingTimer = setInterval(() => {
        if (!this.isTimeout && this.orderId) {
          this.checkPaymentStatus()
        }
      }, 5000)
    },
    clearCountdown () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    async createPayment () {
      alert('进入订单创建流程')
      if (!this.selectedOption || this.selectedOption < 1 || this.selectedOption > 50000) {
        alert('请输入有效的充值金额(¥1-¥50,000)')
        return
      }
      if (!this.selectedMethod) {
        alert('请选择支付方式')
        return
      }
      try {
        const orderData = {
          amount: this.selectedOption,
          paymentMethod: this.selectedMethod
        }
        alert('发送金额:' + orderData.amount + '支付方式:' + orderData.paymentMethod)
        const response = await createOrder(orderData)
        alert('收到响应:' + JSON.stringify(response))
        if (response.status === 200) {
          alert('进入订单创建成功分支')
          this.orderId = response.orderId
          const qrCodeLink = response.qrCodeLink
          this.paymentAmount = this.selectedOption
          this.qrCodeUrl = await QRCode.toDataURL(qrCodeLink)
          this.showPaymentPage = true
          this.countdown = '0:30'
          this.isTimeout = false
        } else {
          console.error('创建订单失败:', response.message)
          alert(response.message)
          alert('创建订单失败,请稍后重试111')
        }
      } catch (error) {
        console.error('创建订单出错:', error)
        alert(error)
        alert('创建订单出错,请稍后重试')
      }
    },
    async checkPaymentStatus () {
      try {
        if (!this.orderId) {
          alert('没有订单ID,无法检查支付状态')
          return
        }
        alert(this.orderId)

        const response = await checkOrderStatus(this.orderId)
        alert(response.message)
        if (response.status === 200) {
          const orderStatus = response.message
          if (orderStatus === 'PAID') {
            this.clearCountdown()
            await this.fetchUserInfo()
            this.showPaymentPage = false
            this.showPaymentSuccess = true
          } else if (orderStatus === 'FAILED') {
            this.clearCountdown()
            this.showPaymentPage = false
            this.showPaymentFailed = true
          }
        } else {
          console.error('检查订单状态失败:', response.message)
        }
      } catch (error) {
        console.error('检查订单状态出错:', error)
      }
    },
    handlePaymentComplete () {
      this.checkPaymentStatus()
    },
    handlePaymentSuccess () {
      this.showPaymentSuccess = false
    },
    handleBack () {
      this.showPaymentPage = false
      this.showPaymentFailed = false
      this.showPaymentSuccess = false
      this.clearCountdown()
      this.isTimeout = false
      this.countdown = '0:60'
      this.qrCodeUrl = null
      this.orderId = null
    }
  },
  watch: {
    showPaymentPage (newVal) {
      if (newVal) {
        this.startCountdown()
      } else {
        this.clearCountdown()
      }
    }
  },
  beforeDestroy () {
    this.clearCountdown()
  }
}
</script>

<style scoped>
.recharge-container {
  min-height: 400px;/* 100vh; */
  background-color: #f5f5f5;
  padding: 0;
  margin-top: -180px;
}

.recharge-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0;
  width: 300px;
}

/* 页面标题 */
.page-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #070000;
  padding: 8px 0;
  background-color: #fff;
  margin-bottom: 10px;
}

/* 信息卡片 */
.info-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 5px;
  margin-bottom: 5px;
}

.card-label {
  font-size: 14px;
  color: #000000;
  margin-bottom: 12px;
}

.balance-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;

  text-align: center; /* 水平居中 */
  display: flex; /* 使用 flex 布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

/* 当前金额 */
.current-amount {
  font-size: 24px;
  font-weight: bold;
  color: #2f96fe;
  letter-spacing: 1px;
  text-align: center; /* 水平居中 */
  display: flex; /* 添加 flex 布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

/* 输入金额 */
.input-container {
  display: flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 0 12px;
  background-color: #fafafa;
}

.currency-symbol {
  font-size: 16px;
  color: #999;
  margin-right: 8px;
}

.amount-input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 14px;
  color: #333;
  padding: 4px 0;
  outline: none;
}

.amount-input::placeholder {
  color: #ccc;
}

.amount-hint {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

/* 支付方式 */
.payment-methods {
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.payment-method {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 3px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  background-color: #fafafa;
}

.payment-method.selected {
  border-color: #409eff;
  background-color: #f0f7ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

.payment-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
}

.payment-icon {
  width: 24px;
  height: 24px;
}

.payment-text {
  font-size: 12px;
  color: #333;
  text-align: center;
  line-height: 1.2;
}

.check-icon-container {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  background-color: #409eff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.check-icon {
  width: 14px;
  height: 14px;
}

/* 底部按钮 */
.button-group {
  display: flex;
  gap: 12px;
  padding: 20px;
  background-color: #fff;
  margin-top: 10px;
}

.btn-secondary,
.btn-primary {
  flex: 1;
  height: 30px;
  border-radius: 4px;
  font-size: 14px;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-secondary {
  background-color: #f5f5f5;
  color: #666;
}

.btn-secondary:hover {
  background-color: #e0e0e0;
}

.btn-primary {
  background-color: #409eff;
  color: #fff;
}

.btn-primary:hover {
  background-color: #66b1ff;
}

/* 支付页面样式保持不变 */
.payment-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 20px auto;
  background-color: #fff;
  border-radius: 8px;
}

.payment-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
}

.header {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.countdown {
  color: #f00;
  font-weight: bold;
}

.amount-instruction {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 10px;
}

.amount-instruction span {
  margin-right: 5px;
}

.price {
  color: #f00;
  font-size: 16px;
  font-weight: bold;
}

.qr-code-container {
  width: 200px;
  height: 200px;
  border: 2px solid #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  border-radius: 8px;
}

.qr-code {
  max-width: 100%;
  max-height: 100%;
}

.buttons {
  display: flex;
  justify-content: center;
  width: 100%;
  gap: 20px;
  margin-top: 20px;
}

.back-button,
.confirm-button {
  padding: 10px 24px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.back-button {
  background-color: #f5f5f5;
  color: #666;
}

.back-button:hover {
  background-color: #e0e0e0;
}

.confirm-button {
  background-color: #409eff;
  color: #fff;
}

.confirm-button:hover {
  background-color: #66b1ff;
}

.timeout-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}

.message {
  text-align: center;
  color: #666;
  font-size: 14px;
}

.payment-failed,
.payment-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 40px 20px;
  background-color: #fff;
  border-radius: 8px;
  max-width: 600px;
  margin: 20px auto;
}

.payment-failed h2,
.payment-success h2 {
  font-size: 22px;
  margin-bottom: 12px;
  color: #333;
}

.payment-failed p,
.payment-success p {
  color: #666;
  font-size: 14px;
  text-align: center;
  margin-bottom: 20px;
}

.retry-button {
  margin-top: 20px;
  padding: 10px 24px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.retry-button:hover {
  background-color: #66b1ff;
}
</style>
